import { Button } from '@mui/material';
import JobAvailabilityDTO from '@src/adapters/dto/job/JobAvailabilityDTO';
import {
  JobBookingStatus,
  JobBookingStatusHubLocked,
} from '@src/constants/JobBookingStatus';
import { useMemo } from 'react';

interface Props {
  availability?: JobAvailabilityDTO;
  availabilityClicked(availability: JobAvailabilityDTO): void;
}

function CrewButton({ availability, availabilityClicked }: Props) {
  const buttonText = useMemo<string>(() => {
    switch (availability?.status) {
      case JobBookingStatus.Booked:
        return 'Booked';
      case JobBookingStatus.Confirmed:
        return 'Confirmed';
      case JobBookingStatus.PencilAccepted:
        return 'Pencil Accepted';
      case JobBookingStatus.Pencilled:
        return 'Pencilled';
      default:
        return 'Unassigned';
    }
  }, [availability]);

  const getButtonColor = (status: JobBookingStatus) => {
    if (status === JobBookingStatus.PencilAccepted) {
      return 'warning';
    } else {
      return 'success';
    }
  };

  return (
    <>
      {availability && (
        <Button
          variant={
            [
              JobBookingStatus.Pencilled,
              JobBookingStatus.Confirmed,
              JobBookingStatus.PencilAccepted,
              JobBookingStatus.Booked,
            ].includes(availability.status)
              ? 'contained'
              : 'outlined'
          }
          color={getButtonColor(availability.status)}
          onClick={() => availabilityClicked(availability)}
          sx={(theme) => ({
            cursor: JobBookingStatusHubLocked.includes(availability.status)
              ? 'not-allowed'
              : 'pointer',
            backgroundColor:
              JobBookingStatus.Pencilled === availability.status ||
              JobBookingStatus.Booked === availability.status
                ? theme.palette.success.light
                : undefined,
          })}>
          {buttonText}
        </Button>
      )}
    </>
  );
}

export default CrewButton;
